import { computed } from "vue";

import { useEmployeeDirectoryViewState } from "./useViewState";

export function useTableConfig() {
  const viewState = useEmployeeDirectoryViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Employee",
          sortable: true,
          value: "employee",
          width: "600px",
        },
        {
          text: "Readiness",
          sortable: true,
          value: "readiness",
        },
        {
          text: "Badges",
          sortable: true,
          value: "badges",
          width: "600px",
        },
      ],
      columns: [
        {
          field: "",
          component: "EmployeeCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeCardProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "EmployeeReadinessBar",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEmployeeReadinessBarProps(item),
          }),
        },
        {
          field: "",
          component: "BadgesCounterLevel",
          props: (item) => ({
            class: "my-4",
            ...viewState.getBadgesCounterLevelProps(item),
          }),
          events: (item) => ({
            onClick: () => {
              viewState.onClickBadgesCounterLevel(item);
            },
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "current_status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: viewState.state.filters.needsRecalculation
        ? false
        : true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      hideFilterBtn: true,
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
    };
  });
  return {
    tableParams,
  };
}
